import { useMutation } from '@tanstack/react-query';
import { useToast } from '@givebutter/primitives/toast';
import { deleteDonorSearch } from 'api/contacts/single';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentContact } from 'customHooks/useCurrentContact';
import { accountQueryKeys } from 'queries/account-query-keys';
import { queryClient } from 'queries/queryClient';
import { GivebutterAxiosError } from 'types/error';

const useDeleteDonorSearch = () => {
    const { accountId } = useCurrentAccount();
    const { data: contact } = useCurrentContact();
    const { error } = useToast();

    return useMutation({
        mutationFn: () => deleteDonorSearch(accountId, contact.id),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: accountQueryKeys.contactById(accountId, contact.id),
            });
        },
        onError: (e: GivebutterAxiosError) => {
            error(e.response?.data?.message || 'Something went wrong.');
        },
    });
};

export { useDeleteDonorSearch };
